<div class="activity-day-date-title">
  <div class="date-title">
    {{day.title | date: 'EEEE, MMM dd'}}
  </div>

  <div class="header-buttons-block">
    <div class="button-label">
      Original Date
    </div>
    <div class="button-label">
      Suggest. Date
    </div>
  </div>
  <div class="space-label">

  </div>
</div>
<div class="suggestion-list" cdkDropList (cdkDropListDropped)="suggestionDrop($event)"
     [cdkDropListData]="day.activities">
  <app-suggestion-activity class="suggestion-line {{activity.id}}" *ngFor="let activity of day.activities" cdkDrag
                           (cdkDragStarted)="dndStart()"
                           (cdkDragEnded)="dndEnd()"
                           [cdkDragDisabled]="true"
                           [dndActive]="dndActive"
                           [activity]="activity">
  </app-suggestion-activity>
</div>
